import { DatePicker } from "@flash-tecnologia/hros-web-ui-v2";
import styled, { keyframes } from "styled-components";

export const Container = styled.div`
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
  padding: ${({ theme }) => theme.spacings.m} 0;
`;

export const RadioCard = styled.div<{ checked?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings.xs2};
  padding: ${({ theme }) => theme.spacings.s};
  border-radius: 12px;
  border: 1px solid
    ${({ theme, checked }) =>
      checked ? theme.colors.secondary[80] : theme.colors.neutral[90]};

  &:hover {
    border-color: ${({ theme }) => theme.colors.secondary[80]};
  }

  @media screen and (max-width: 720px) {
    flex-direction: column;
    align-items: center;
    max-height: 300px;
    gap: 0px;
  }
`;

const bounceIn = keyframes`
  0% {
    opacity: 0;
    transform: scale3d(0.5, 0.5, 0.5);
  }
  30% {
    transform: scale3d(1.05, 1.05, 1.05);
  }
  50% {
    opacity: 1;
    transform: scale3d(0.95, 0.95, 0.95);
  }
  100% {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
`;

export const AnimatedDatePicker = styled(DatePicker)`
  animation: ${bounceIn} 1s ease both;
`;
